import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ViewTemplateIcon } from '@dev/ee-components';

import { Template } from '@dev/ee-api/ee-api-models';
import { getApiPath } from '@/services/Secuirty';
import { SetTemplatePreview, getPaidNewsletterCreatorStore } from '@/store/paidNewsletterCreator/actions';

import { TemplatePreviewButton } from '@/assets/TemplatePreviewButton';
import { ScreenshotWrapper, ScreenshotHover } from './styles';

export const Step2Content = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { paidNewsletterObject } = useSelector(getPaidNewsletterCreatorStore);
    const templateObject: Template = paidNewsletterObject?.ProductLanding?.Template;
    const templateScreenshot = templateObject?.Screenshot;

    const viewTemplate = (): void => {
        dispatch(SetTemplatePreview(templateObject?.Body?.Parts?.find((part) => part.ContentType === 'text/html')?.Content));
    };

    return (
        <ScreenshotWrapper>
            <ScreenshotHover>
                <TemplatePreviewButton
                    id={"landingpage-view-template"}
                    buttonIcon={<ViewTemplateIcon width={28.8} height={28.8} />}
                    buttonLabel={t('view')}
                    handleOnClick={viewTemplate}
                />
            </ScreenshotHover>
            {templateScreenshot && <img src={`${getApiPath()}/userfile${encodeURI(templateScreenshot)}`} />}
        </ScreenshotWrapper>
    );
}
